<template lang="pug">
  b-card.p-10.transit-card
    .container-fluid.m-0
      .row
        b-col.col-st.d-none.d-md-block(md="3")
          div.simple-elmnt.mb-1.c-animated-background(style="height:70px")
          div.simple-elmnt.mb-1.c-animated-background.text-holder-m
          div.simple-elmnt.mb-1.c-animated-background.text-holder-m
        b-col.col-st.d-block.d-md-none.pl-3.pr-3.pt-2.pb-2(md="3")
          div.simple-elmnt.mb-1.c-animated-background(style="height:70px")
          div.simple-elmnt.mb-1.c-animated-background.text-holder-m
          div.simple-elmnt.mb-1.c-animated-background.text-holder-m
          div.simple-elmnt.mb-1.c-animated-background.text-holder-m
          div.simple-elmnt.mb-1.c-animated-background.text-holder-m
        b-col.col-st-2.d-none.d-md-block(md="1")
          .div.c-animated-background.text-holder-m.mb-2
          .div.c-animated-background.text-holder-m.mb-2
          .div.c-animated-background.text-holder-m
        b-col.col-st.d-none.d-md-block(md="4")
          .div.c-animated-background.text-holder-m.mb-2
          .div.c-animated-background.text-holder-m.mb-2
          .div.c-animated-background.text-holder-m
        b-col.col-st.d-none.d-md-block(md="4")
          .div.c-animated-background.text-holder-m.mb-2
          .div.c-animated-background.text-holder-m
</template>

<script>
import TransitMixin from '@/mixins/Transit'

export default {
  name: 'TransitClient',
  mixins: [TransitMixin],
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {

  }
}
</script>

<style>
  .text-holder-m{
    height: 25px;
  }
  .col-st{
    padding-left: 5px;
    overflow: hidden;
  }
  .col-st-2{
    padding-right: 0;
    overflow: hidden;
  }
  hr{
    border-color: whitesmoke;
  }
</style>
